<template>
  <div class="content">
    <h1 class="has-text-centered">Netzwerksicherheit</h1>
    <div class="box">
      <p>Eine kompakte Zusammenfassung über Firewall, Virenschutz und Intrutiondetection als Sicherheitsaspekte eines Netzwerkes.</p>
      <FAQsTableOfContents :faqs="faqs" />
    </div>

    <div class="box">
      <FAQs :faqs="faqs" :h_level="2" />
    </div>

    <FeedbackBox />
  </div>
</template>

<script>
import FeedbackBox from '@/components/FeedbackBox.vue'
import FAQs from '@/components/FAQs.vue'
import FAQsTableOfContents from '@/components/FAQsTableOfContents.vue'

export default {
  name: 'theory-network-security',
  components: {
    FeedbackBox,
    FAQs,
    FAQsTableOfContents
  },
  metaInfo: {
    title: 'Netzwerksicherheit | Elektrotechnik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Eine kompakte Zusammenfassung über Firewall, Virenschutz und Intrutiondetection als Sicherheitsaspekte eines Netzwerkes.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'network-engineering' })
  },
  data () {
    return {
      faqs: [
        {
          question: 'Was macht eine Firewall?',
          answer:
            '<ul>' +
            '  <li>Dient der Prävention</li>' +
            '  <li>Schützt Rechnernetze oder einzelne Computer vor unerwünschten Netzwerkzugriffen</li>' +
            '  <li>Teilaspekt eines Sicherheitskonzeptes</li>' +
            '  <li>Anhand festgelegter Regeln wird bestimmt, ob ein Netzwerkpaket durchgelassen wird oder nicht</li>' +
            '</ul>'
        },
        {
          question: 'Welche Sicherungsmechanismen bietet eine Firewall?',
          answer:
            '<h3>Paketfilterung</h3>' +
            '<ul>' +
            '  <li>Datenpaket des Internet Protokolls enthält Informationen über die Absender-, sowie Zieladresse</li>' +
            '  <li>Firewall kann genutzt werden, nur bestimmte Pakete durchzulassen</li>' +
            '</ul>' +
            '<h3>NAT (Network Address Translation)</h3>' +
            '<ul>' +
            '  <li>Für eine Verbindung über Internet müssen IP Adressen ausgetauscht werden</li>' +
            '  <li>Mithilfe von "Port Adresse Translation" kann die Firewall über eine einzige IP-Adresse mehrere Verbindungen ermöglichen</li>' +
            '  <li>Mit NAT stellt Firewall sicher, dass die Antwort aus dem Internet wieder an die Firewall geschickt wird</li>' +
            '  <li>Keine direkte Verbindung zwischen beiden Teilnehmern</li>' +
            '</ul>' +
            '<h3>Sonstige Mechanismen</h3>' +

            '<ul>' +
            '  <li>' +
            '    <strong>VPN</strong> (Virtual Private Network)' +
            '  </li>' +
            '  <ul>' +
            '    <li>Verbinden lokale Netzwerke über das Internet</li>' +
            '  </ul>' +
            '  <li><strong>Proxy-Server</strong></li>' +
            '  <ul>' +
            '    <li>System welches zwischen lokalem Netzwerk und Internet steht und das Netzwerk nach außen mit einer IP repräsentiert</li>' +
            '    <li>Netzwerkverkehr nur über den Proxy-Server wodurch Netzwerkverkehr leichter kontrollierbar wird</li>' +
            '  </ul>' +
            '  <li><strong>IPsec</strong></li>' +
            '  <ul>' +
            '    <li>IP Security</li>' +
            '    <li>Verschlüsselt per Internet Protokoll versendete Daten</li>' +
            '  </ul>' +
            '  <li><strong>Port Forwarding</strong></li>' +
            '  <ul>' +
            '    <li>Ermöglicht es Anfragen an bestimmte Ports umzuleiten (Anfrage an Port A geht eigentlich an Port B)</li>' +
            '  </ul>' +
            '</ul>'
        },
        {
          question: 'Was sind Vor- und Nachteile einer Firewall?',
          answer:
            '<h3>Vorteile</h3>' +
            '<ul>' +
            '  <li>Dient der Prävention</li>' +
            '  <li>Netzwerkverkehr wird kontrolliert</li>' +
            '  <li>Filtert ein- und ausgehenden Traffic aus Netzwerken</li>' +
            '</ul>' +
            '<h3>Nachteile</h3>' +
            '<ul>' +
            '  <li>Kann ein System spürbar bremsen, wenn falsch konfiguriert</li>' +
            '  <li>Muss richtig konfiguriert werden um den reibungslosen Betrieb weitere Software zu gewährleisten</li>' +
            '  <li>Kann unter Umständen (fehlende Updates, falsche Konfiguration) die Sicherheit verringern</li>' +
            '</ul>'
        },
        {
          question: 'Was ist ein Intrusion Detection System (IDS)?',
          answer:
            '<ul>' +
            '  <li>Angriffserkennungssystem</li>' +
            '  <li>Überwachen und analysieren von Aktivitäten in einem Netzwerk</li>' +
            '  <li>Erkennt typische Angriffsmuster</li>' +
            '  <li>Analysiert und meldet verdächtige Aktivitäts-Muster</li>' +
            '</ul>'
        },
        {
          question: 'Welche Architekturen von IDS gibt es?',
          answer:
            '<h3>Host-basierte IDS</h3>' +
            '<ul>' +
            '  <li>Unterstützt das Betriebssystem</li>' +
            '  <li>Überprüft Log-Dateien, Kernel-Daten und andere Systemdaten</li>' +
            '  <li>Vorteile</li>' +
            '  <ul>' +
            '    <li>Sehr spezifische Aussagen über den Angriff</li>' +
            '    <li>Kann ein System umfassend überwachen</li>' +
            '  </ul>' +
            '  <li>Nachteile</li>' +
            '  <ul>' +
            '    <li>Kann durch einen DoS-Angriff ausgehebelt werden</li>' +
            '    <li>Wenn das Host-System außer Gefecht gesetzt wurde, ist auch das IDS lahmgelegt</li>' +
            '  </ul>' +
            '</ul>' +
            '<h3>Netzwerk-basierte IDS</h3>' +
            '<ul>' +
            '  <li>Überwachen und analysieren den gesamten Netzwerkverkehr</li>' +
            '  <li>Versuchen im Netzwerkverkehr Angriffsmuster zu erkennen</li>' +
            '  <li>Das System mit der IDS-Software nennt man "Sensor"</li>' +
            '  <li>Vorteile</li>' +
            '  <ul>' +
            '    <li>Ein Sensor kann ein ganzes Netz überwachen</li>' +
            '    <li>Durch Ausschalten eines Ziel-Systems ist die Funktion des Sensors nicht gefährdet</li>' +
            '  </ul>' +
            '  <li>Nachteile</li>' +
            '  <ul>' +
            '    <li>Keine lückenlose Überwachung bei Überlastung der Bandbreite des IDS</li>' +
            '    <li>Keine lückenlose Überwachung in geswitchten Netzwerken</li>' +
            '  </ul>' +
            '</ul>' +
            '<h3>Hybride IDS</h3>' +
            '<ul>' +
            '  <li>Kombination aus Host-basierten und Netzwerk-basierten IDS</li>' +
            '  <li>Bestehend aus folgenden Kompenten:</li>' +
            '  <li>Management</li>' +
            '  <li>Hostbasierte Sensoren (HIDS)</li>' +
            '  <li>Netzbasierte Sensoren (NIDS)</li>' +
            '</ul>'
        },
        {
          question: 'Wie funktioniert ein IDS?',
          answer:
            '<ul>' +
            '  <li>Zweistufiger Prozess</li>' +
            '  <li>' +
            '    Erster Schritt: Host-basiert, passive Stufe' +
            '  </li>' +
            '  <ul>' +
            '    <li>Inspiziert Konfigurations-Dateien und prüft sie auf "falsche" Einstellungen</li>' +
            '  </ul>' +
            '  <li>' +
            '    Zweiter Schritt: Netzwerk-basiert, aktive Stufe' +
            '  </li>' +
            '  <ul>' +
            '    <li>Das System simuliert Angriffe und analysiert die Reaktionen des Systems (genannt "Penetrationtest")</li>' +
            '  </ul>' +
            '</ul>'
        },
        {
          question: 'Was macht ein Anti-Viren-Programm?',
          answer:
            '<ul>' +
            '  <li>Scannt das System und neue Dateien auf bekannte Signaturen</li>' +
            '  <li>Versucht Schädlinge sschnell wie möglich anhand ihrer Signatur zu erkennen</li>' +
            '  <li>Versucht von Schädlingen bereits vorgenommene Veränderungen des Systems rückgängig zu machen</li>' +
            '</ul>'
        },
        {
          question: 'Was gibt es bei Anti-Viren- und Virenschutz Programmen noch zu beachten?',
          answer:
            '<ul>' +
            '  <li>Diese Sicherheitssysteme müssen immer auf dem aktuellsten Stand sein um ...</li>' +
            '  <ul>' +
            '    <li>... aktuelle Viren/Schadcode identifizieren zu können</li>' +
            '    <li>... um nicht selbst zur Sicherheitslücke zu werden (auch Software welche selbst zur Beseitigung/Prävention von Viren dient, kann bei ausbleibenden Updates zur Sicherheitslücke werden)</li>' +
            '  </ul>' +
            '</ul>' +
            '<ul>' +
            '  <li>' +
            '    Es besteht die Gefahr von sogenannten "False-Positives". Dabei wird eine Datei fälschlicherweise als Schadcode identifiziert. Das kann im schlimmsten Fall zurs Instabilität eines Systems führen.' +
            '  </li>' +
            '</ul>'
        },
        {
          question: 'Was sind Ansätze zur Virenbeseitigung?',
          answer:
            '<p>' +
            '  Besonders in Netzwerken muss je nach System-/Serverrolle (Fileserver, Mailserver, Webserver, ...) genau überlegt werden, welche Methoden beziehungsweise Ansätze eingesetzt werden sollen.' +
            '  Optimalfall: Individuelles Schutzsystem für jeden Teilnehmer im Netzwerk.' +
            '</p>' +
            '<ul>' +
            '  <li><strong>Heuristischer Ansatz</strong></li>' +
            '  <ul>' +
            '    <li>Anhand festgelegter Regeln werden Signaturen untersucht und als gegebenenfalls als</li>' +
            '    <li>Schadcode erkennt</li>' +
            '    <li>Nur für unkritische Bereiche, weil die Gefahr für "False-Positives" hoch ist</li>' +
            '  </ul>' +
            '</ul>' +
            '<ul>' +
            '  <li><strong>Mehrere Scan-Engines</strong></li>' +
            '  <ul>' +
            '    <li>Manche Entwickler nutzen zwei verschiedene Virenscanner in einer Software um eine höhere Erkennungsrate zu erreichen</li>' +
            '  </ul>' +
            '</ul>' +
            '<ul>' +
            '  <li><strong>Möglichst viele Updates</strong></li>' +
            '  <ul>' +
            '    <li>Stündlich werden neue Viren und neuer Schadcode im Internet entdeckt. Um dagegen anzukommen wird versucht soviele Updates wie möglich zu realisieren</li>' +
            '  </ul>' +
            '</ul>' +
            '<ul>' +
            '  <li><strong>Proaktive Erkennung</strong></li>' +
            '  <ul>' +
            '    <li>Erkennen und blockieren schädliche Handlung und melden diese den Antiviren-Herstellern damit mit dem nächsten Update die Signatur des Schadcodes erkannt werden kann</li>' +
            '    <li>Dieser Ansatz greift sehr tief ins System ein, daher sollte der Einsatz wohlüberlegt sein</li>' +
            '    <li>Verbraucht auch mehr Ressourcen als andere Ansätze</li>' +
            '  </ul>' +
            '</ul>' +
            '<ul>' +
            '  <li><strong>Sandbox</strong></li>' +
            '  <ul>' +
            '    <li>Überprüfungen finden in einer virtuellen (isolierten) Umgebung statt</li>' +
            '    <li>Schadcode mit verzögertem Start könnte nicht erkannt werden</li>' +
            '  </ul>' +
            '</ul>' +
            '<ul>' +
            '  <li><strong>Whitelisting</strong></li>' +
            '  <ul>' +
            '    <li>Sicherste Methode, aber auch aufwendigste Methode</li>' +
            '    <li>Es wird eine Liste festgelegt mit sicheren Programmen/Dateien ("Whitelist") und jede/s Datei/Programm welches nicht in dieser Liste vorkommt gilt als unsicher bzw. als Schadcode</li>' +
            '  </ul>' +
            '</ul>'
        }
      ]
    }
  }
}
</script>
